












































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import CouponApi from '@/api/marketing/couponActivity/index'
import newCouponApi from '@/api/marketing/coupon/index'
import CustomForm from '@/components/custom-form/index.vue'
import AbpBase from '@/lib/abpbase'
@Component({
  components: {
    CustomForm,
  },
})
export default class CouponActivitySelect extends AbpBase {
  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: true,
  })
  showBtn!: boolean

  @Prop({
    type: Boolean,
    default: false,
  })
  show!: boolean

  @Prop({
    type: Boolean,
    default: true,
  })
  IsMultiple!: boolean

  // 活动券类型 limitBuyCoupon 限时购券 helpGetCoupon 助力领券
  @Prop({
    type: String,
    default: null,
  })
  type!: string

  @Watch('show')
  showChange(show) {
    this.modal1 = !this.modal1
  }

  modal1: boolean = false
  total: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  data = []
  filters = [
    {
      label: '优惠券名称',
      type: 'input',
      props: {
        placeholder: '请输入优惠券名称',
      },
      key: 'keyWord',
    },
  ]

  get columns() {
    var data: any[] = [
      {
        title: '活动名称',
        key: 'name',
        align: 'center',
      },
      {
        title: this.type == 'selectCoupon' ? '优惠券类型' : '活动类型',
        key: this.type == 'selectCoupon' ? 'couponTypeDisplayName' : 'activityTypeDisplayName',
        align: 'center',
      },
      {
        title: '开始时间',
        slot: 'beginTime',
        align: 'center',
      },
      {
        title: '结束时间',
        slot: 'endTime',
        align: 'center',
      },
    ]
    if (this.IsMultiple) {
      data.splice(0, 0, {
        type: 'selection',
        width: 60,
        align: 'center',
      })
    }
    return data
  }

  @Watch('modal1')
  modalShowChange(show) {
    if (show) this.submitFn()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  submitChange(form, valid) {
    if (valid) {
      this.getList(form)
    }
  }

  async getList(form?) {
    let keyWord = null
    let categoryId = null
    let vm = this
    if (form) {
      keyWord = form['keyWord']
    }
    if(vm.type == 'selectCoupon') {
      await newCouponApi.getList(vm.pageSize, vm.pageIndex, false, keyWord).then(res => {
        vm.total = res.data.totalCount
        vm.data = res.data.items
      })
    }else {
      await CouponApi.getCouponList(vm.pageSize, vm.pageIndex, vm.type, keyWord, 1, true).then((res) => {
        vm.total = res.data.totalCount
        vm.data = res.data.items
      })
    }
    
  }

  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    await this.submitFn()
  }
  currentChange(currentRow, oldCurrentRow) {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', currentRow)
      this.modal1 = false
    }
  }
  ok() {
    this.$emit('on-change', (this.$refs.selection as any).getSelection())
    this.modal1 = false
  }

  cancel() {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', null)
    } else {
      this.$emit('on-change', [])
    }
    this.pageSize = 10
    this.pageIndex = 1
    this.modal1 = false
  }
}
